var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"CLOCK":"","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2","stroke":"currentColor","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }